/**
  * Проверить права на действия
  * @param {
 *   user: {}
 *   rights: String[] | String
 *  } params
 * @return boolean
*/
const haveRights = (user, rights = []) => {
  if (!user.parent_id) return true;

  const { actions: userActions = [] } = user;

  if (Array.isArray(rights)) {
    if (!user.actions.length) return false;
    return rights.every((action) => userActions.includes(action));
  }

  if (typeof rights === 'number') {
    return userActions.includes(rights);
  }

  return false;
};
export default haveRights;
